let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2zH6i")).then(() => parcelRequire('6yL5N'));